/**
 * Nur auf localhost oder bei ?debug=1 / localStorage debugLogs ausgeben.
 * Verhindert Debug-Logs in Production (z. B. siqment.com).
 */
export function isDebugLogEnabled() {
    if (typeof window === 'undefined') return false;
    const host = window.location?.hostname;
    if (host === 'localhost' || host === '127.0.0.1' || host === '::1') return true;
    if (new URLSearchParams(window.location?.search || '').get('debug') === '1') return true;
    if (window.localStorage?.getItem('debugLogs') === 'true') return true;
    return false;
}

export function debugLog(...args) {
    if (isDebugLogEnabled()) console.log(...args);
}
